import * as React from 'react';
import { XIconLarge } from '../icons';
import styled from '@emotion/styled';

export const OverlayStyles = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 50;
`;
export const ModalWrap = styled.div`
  background-color: #fff;
  //   left: 50%;
  position: absolute;
  //   right: 50%;
  top: 100;
  //   transform: translateX(-50%);
  z-index: 3000;
  scroll-behavior: auto;
`;

interface Props {
  url: string;
  onClose: () => void;
  width?: string;
}

export default function Iframe(props: Props) {
  return (
    <React.Fragment>
      {/* <Global
        styles={{
          body: { overflow: "hidden" },
          html: { overflow: "hidden" },
        }}
      /> */}
      <OverlayStyles />
      <ModalWrap>
        {/* <button onClick={onClose}>close</button> */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: 16,
            cursor: 'pointer',
          }}
        >
          <XIconLarge onClick={props.onClose} />
        </div>
        <div style={{ maxHeight: 'calc(100vh -56px)', overflow: 'scroll' }}>
          <iframe
            title="doc-preview"
            src={`${props.url}`}
            style={{
              // width: 545,
              width: `${props.width ? props.width :  '545px'}`,
              height: 675,
              border: '1px solid black',
              overflow: 'auto',
            }}
          ></iframe>
        </div>
      </ModalWrap>
    </React.Fragment>
  );
}
